const availableRoutes = {
  login: '/login',
  passwordReset: '/passwordreset',
  setNewPassword: '/setnewpassword',
  forgotpassword: '/forgotpassword',
  register: '/register',
  loadDetails: '/loads/:id',
  profile: '/user/settings',
  logout: '/logout',
  tourPlanner: '/tour-planner/*',
  locations: '/locations',
  locationDetails: '/locations/:id',
  dashboard: '/dashboard',
  carrierNetwork: '/carrier-network',
  dispatchers: '/dispatchers/:id',
  rateManagement: '/rate-management/:id',
  loads: '/loads',
  vehicles: '/vehicles',
  vehiclesDetails: '/vehicles/:id',
  shipmentExecution: '/shipment-execution/*',
  dataExport: '/data-export',
  orders: '/orders',
  orderPlanning: '/order-planning',
  packages: '/orders/packages/*',
  articles: '/orders/articles',
  ordersLoads: '/orders/loads',
  ordersLocations: '/orders/locations',
  userManagement: '/user-management',
  fleetManagement: '/fleets',
  analytics: '/analytics',
} as const;

export { availableRoutes };
